module.exports = __webpack_public_path__ + "static/OpenSans-Regular-d7d5d4588a9f50c99264bc12e4892a7c.ttf";